<form #dataForm="ngForm" (ngSubmit)="onSubmit(dataForm)">
  <mat-form-field class="example-chip-list">
    <mat-chip-list #chipList aria-label="placeholder">
      <mat-chip
        *ngFor="let tg of value"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(tg)">
        {{tg.name}}
        <mat-icon class="closeBtn" matChipRemove *ngIf="removable">close</mat-icon>
      </mat-chip>
      <input
        placeholder="{{ placeholder | translate}} {{required ? '*' : ''}}"
        #tagInput
        [formControl]="tagCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)" matChipInputAddOnBlur="false">
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let tg of filteredTags | async" [value]="{_id: tg._id, name: tg.name}">
        {{tg.name}}
        <mat-icon *ngIf="canDelete" class="material-icons deleteItem" (click)="checkDeleteItem($event, tg)">cancel</mat-icon>
      </mat-option>
    </mat-autocomplete>
    <mat-hint align="end" style="width: 50%;">{{'To create a new item you need to write down the word if it is not in the list and click enter to create it'| translate}}</mat-hint>
    <div class="my-error mat-error mat-form-field-subscript-wrapper" *ngIf="parentFormSubmitted && required && (value === undefined || value.length === 0)">
      {{placeholder | translate}} is required.
    </div>
  </mat-form-field>
</form>
